module.exports = __webpack_public_path__ + "static/media/all_active.df2555b5.svg";